export default __webpack_public_path__ + "static/media/fileimage.1d899299.jpg";